
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-97d8de4c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ConfluenceLinkedRequirementsMacroEditorView.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ConfluenceLinkedRequirementsMacroEditorView.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-97d8de4c\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ConfluenceLinkedRequirementsMacroEditorView.vue"),
  /* scopeId */
  "data-v-97d8de4c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/confluence/ConfluenceLinkedRequirementsMacroEditorView.vue
// module id = 976
// module chunks = 1